export default __webpack_public_path__ + "static/media/binance-logo.6c17a134.png";